import { getPrices, getPriceVariant, isPriceRange } from '@libs/algolia';
import { formatPrice, ProductPriceDisplay, type ProductPriceDisplayProps } from '@libs/common-next';
import type { PriceData } from '@libs/common-types';

type ProductPriceProps = {
    price: PriceData;
};

export function ProductPrice({ price }: Readonly<ProductPriceProps>) {
    const isRange = isPriceRange(price);
    const values = getPrices(price, isRange).map(formatPrice);
    const isOnSale = getPriceVariant(price) === 'disabled';
    const [currentPrice, secondPrice] = values;

    if (!currentPrice) return null;

    const isSaleRange = isOnSale && values.length === 4;
    const displayProps: ProductPriceDisplayProps =
        isRange && secondPrice && (!isOnSale || isSaleRange)
            ? {
                  className: 'header-search__price',
                  fromPrice: currentPrice,
                  isOnSale: isSaleRange,
                  toPrice: secondPrice,
                  type: 'range',
              }
            : {
                  className: 'header-search__price',
                  originalPrice: isOnSale ? secondPrice : undefined,
                  price: currentPrice,
                  type: 'default',
              };

    return <ProductPriceDisplay {...displayProps} />;
}
